<rask-fieldset-toggle
  [formGroup]="form"
  [defaultExpanded]="open"
  label="Destineringsområde"
  (click)="initDestineringsomraden()"
  [nrOfSelectedFilters]="filterLength">

  @if (isLoaded) {
    <rask-multi-selector
      label="Destineringsområde"
      bindValue="key"
      bindLabel="value"
      class="w-100"
      [items]="options"
      (change)="selectionChanged($event)"
      [selected]="control.value"
      [portalToBody]="true">
    </rask-multi-selector>
  }
</rask-fieldset-toggle>